import { Component, Input, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  imports: [CommonModule],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header implements OnInit {
  @Input() title: string = 'BarBook';
  @Input() showLogo: boolean = true;
  @Input() compact: boolean = false;
  showBackButton: boolean = false;

  constructor(private router: Router) {}

  ngOnInit() {
    // Detectar cambios de ruta
    this.updateBackButton(this.router.url);
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.updateBackButton(event.url);
      });
  }

  private updateBackButton(url: string) {
    // Mostrar botón de volver solo en rutas de detalle
    this.showBackButton = url.startsWith('/bar/') || url.startsWith('/list/');
  }

  goHome() {
    this.router.navigate(['/']);
  }

  goBack() {
    this.router.navigate(['/search']);
  }
}
